@if (displayText !== 'ID') {
  <div class="formly__wrapper">
    <atom-accordion [displayMode]="'flat'">
      <atom-accordion-header header [grow]="true" [align]="'center'">
        <div title>
          <div class="d-flex align-items-center">
            <!--ICONS-->
            <!--ERRORS-->
            @if (axErrorObject.count > 0) {
              <span
                class="d-flex align-items-center badge rounded-circle badge-primary mr-4">
                @if (axErrorObject.type.toLowerCase() == 'error') {
                  <atom-image [type]="'icon'"
                    [src]="icons.Warning_triangle"
                    [color]="colors.Red">
                  </atom-image>
                }
                @if (axErrorObject.type.toLowerCase() == 'warning') {
                  <atom-image [type]="'icon'"
                    [src]="icons.Notification_active"
                    [color]="colors.Purple">
                  </atom-image>
                }
              </span>
            }
            @if (axErrorObject.count <= 0 && formControl.status === 'INVALID') {
              <span
                class="d-flex align-items-center badge rounded-circle badge-primary mr-4">
                <atom-image [type]="'icon'"
                  [src]="icons.Warning_triangle"
                  [color]="colors.Red">
                </atom-image>
              </span>
            }
            <!--GREEN TICK-->
            @if (axErrorObject.count === 0 && formControl.status === 'VALID') {
              <span
                class="d-flex align-items-center badge rounded-circle badge-danger mr-4">
                <atom-image [type]="'icon'" [src]="icons.Check" [color]="colors.Green">
                </atom-image>
              </span>
            }
            <!--TEXT-->
            <span><strong>{{ displayText | BreakString }}</strong></span>
            <!--REQUIRED STAR-->
          </div>
        </div>
        @if (field['showAddButton']) {
          <atom-button post [type]="buttonType.Secondary" [width]="'270px'" (click)="add($event)">
            <atom-image pre [type]="'icon'" [src]="icons.Add" [color]="colors.Black" [size]="size.lg"></atom-image>
            <div text>{{displayText}}</div>
          </atom-button>
        }
      </atom-accordion-header>
      <div body class="formly__array--body">
        @if (axErrorDisplayObject.errors.length > 0) {
          <div
            class="formly-feedback formly-feedback mb-2 mt-0"
            [ngClass]="axErrorDisplayObject.type === 'error' ? 'formly-feedback--error' : 'formly-feedback--warning'"
            >
            @for (err of axErrorDisplayObject.errors; track $index; let index = $index) {
              <div>
                @if (err && err !== '') {
                  <div style="padding: 5px">{{err}}</div>
                  @if (index > 0 && index !== axErrorDisplayObject.errors.length - 1) {
                    <hr/>
                  }
                }
              </div>
            }
          </div>
        }
        @for (field of field.fieldGroup; track $index; let i = $index) {
          <div class="row">
            @if (field['isDeleted'] === undefined || field['isDeleted'] === false) {
              <div class="col-12">
                <formly-field [field]="field"></formly-field>
              </div>
            }
          </div>
        }
      </div>
    </atom-accordion>
  </div>
}
